var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/project"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.297 18.386h-2.354m2.354-2.725h-5.094m5.094-2.73h-3.445M11.52 4.188h-.012m0 0H5.484a2.669 2.669 0 0 0-2.668 2.669V9.45m8.692-5.264.277-.643a2.226 2.226 0 0 1 2.04-1.36h4.56a3.431 3.431 0 0 1 3.432 3.43v12.772a3.431 3.431 0 0 1-3.431 3.43H5.614a3.431 3.431 0 0 1-3.43-3.43v-6.95c0-.74.233-1.425.632-1.985m8.692-5.264c-.601 1.377-1.395 3.085-1.933 3.818h-3.96c-1.156 0-2.178.57-2.8 1.446",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.33437f0496ff3b16c8bd0646138c439c.svg";
export { ForwardRef as ReactComponent };